import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import * as moment from 'moment'


@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css']
})
export class CareerComponent implements OnInit {

  CareerList: any;
  
  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    GetAllCareer() {
    this.spinnerService.show();
    this.adminservice.GetAllCareer().subscribe((response: any) => {
      this.CareerList = response.CareerList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };


  
  ngOnInit() {
    this.GetAllCareer();
  }



}







